module.exports = __webpack_public_path__ + "img/hyundai-used.d39a6a00.png";